const Icon3 = ({className = '', ...props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="72"
    height="72"
    fill="none"
    viewBox="0 0 72 72"
    className={className}
      {...props}
  >
    <path
      fill="url(#pattern0_111_1917)"
      d="M0 0h71.174v71.174H0z"
      transform="matrix(-1 0 0 1 71.465 .212)"
    ></path>
    <defs>
      <pattern
        id="pattern0_111_1917"
        width="1"
        height="1"
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#image0_111_1917" transform="scale(.01111)"></use>
      </pattern>
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEpUlEQVR4nO2c229VRRSHd9BoNSoIvoIx3jUxJoq+QvQfMMUW47OxVWNjNNKCeIuGkPBMfAHfQBLENuqzFwxCA/qA6JOXxCNEqZcWpcXi+czEOWQznD0ze3dmn9nH9SVNc9qZ/matzplZs2btk2WCIAiCIAiCIAiCIAiCIAiCIAiCIAhCcwCuAh4GXgHeAb4ETgKz/Mesfv2F/r1q95Dq1+uxJw8wAAwDHwILVGMBeB8YUn+v1zYlBXAtMAacIiyngVeB67P/M8BlwDPA78TlN2AUWBbRlhuAl4FjwJ/66yiwFVgVS9dnYLfrgdTJEeDWCLZsdEwW9Y8eDq3rM7DHgTP0hrmQRusZ60MbmAil6zOwLZEd6Wv0eABbnqY8IyU1ntOTY6xMpx2kxfYqDta23A2cqxgV3emp8QBwXvdbBNb6dHqJNBmv4ORlwGdL0DysAgEPnf1Gv30+a3KqtFXMXdLRTwXQHfWIYtQszvN3YQSjdvncaS5VzgB3lAhJvwug+QNwuUXnsYJ+w0WDqjuEW0ro54yzgUcJx6BF5+2CPru7NVaHkSYx4uHoQwH1Dlp0ThT0+cpsuKKGE19ofgWWW4y/KbgirOmic3Uu2jBZvChxlnCU4WIi8ibofBcBDzr63J9PcaqEThP5pSjrB3wQQW+qxEZ48YaoU51NZkMX468E/oqgpZJPVxhaE44+mzoNVT65yUx1cfS9EfXuMbTecrTf2VnIqybtU2HevKmJfOjaaGhNOdofyPT1Uz+w3jD+zYharxtaBx3tP8703V0/sNUw/r2IWu96xtAdjmf6orQf2GMYPx1R67ChpS6dbbQyfVvdDxwzjP8motbXhpa6kbExk0W4YO0VLcP4nyJq/WhoqZDPxlzWwyuq0Mwaxqtbjrq0VDrUxkJmOaM3jfOG8THtWjS0VI7cxj8yo2uc0a4dsym0Ul+jVS1cP3C0xqjjhKGl0rXOqKNf4+gjqcXR/XoyPBBRa3+Vk6Eqne0H1hnGvxFR6zVD61NH+486pbcq+9Vk5s3kf83Zu0mv3IiuT24yk3nDk8xH64aqCLzJDCZ+w/Jip+GAvntrIj8rp5qOjvhOnaxwZziUWtVo0Fo8XcwemicLihtt3JdvvNwj3Zcap4HrLI6+MYLm6gp1HQN1zICYPFHk5JxNS6kiNfnEolMUSx8vKm+NeTMRks89a+8GA2o+YtHZXdBnV1GHWxpQTToH3OZycq5w89sAmt/baqT1czHdKC4x1gU1rhxrr2jbqjoL7BmNsQkaGqu6pEvV65WuwY2TJs+XcXJuSXSVBNg45LlM7TP67fUd4HbSYltZJ+dsuatiodB8iaL3tbmq/8ULxY2enTclsIy0gReqOjlny0iMyMbQGNN73LNVBjjUww3yj7JrssOWzZ4Tp33h6Fwn+tmWmMn0ohDu5gi2DDluRWa6VajWht5URjyubpbKjHrLRn4WfKVOO0znngWf1jM+jYf+gWv0WnQy0qcbrOi1jUmhs34bdNnq2YrOPasT54NFWTjhUqev1w+179Ufz9DSmxn6e0v/fI9ut06cKwiCIAiCIAiCIAiCIAiCIAiCIGRd+RfU6TJyV4XwWgAAAABJRU5ErkJggg=="
        id="image0_111_1917"
        width="90"
        height="90"
        preserveAspectRatio="none"
      ></image>
    </defs>
  </svg>
);

export default Icon3;
